export default __webpack_public_path__ + "static/media/cert-student-cpttm-sc.3110ea81.jpg";